var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon38BlogPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 4.12a1.12 1.12 0 1 0-2.24 0v6.69H4.12a1.12 1.12 0 1 0 0 2.23h6.84v6.84a1.12 1.12 0 1 0 2.23 0v-6.84h6.7a1.12 1.12 0 1 0 0-2.23h-6.7V4.1z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0xMy4yIDQuMTJhMS4xMiAxLjEyIDAgMSAwLTIuMjQgMHY2LjY5SDQuMTJhMS4xMiAxLjEyIDAgMSAwIDAgMi4yM2g2Ljg0djYuODRhMS4xMiAxLjEyIDAgMSAwIDIuMjMgMHYtNi44NGg2LjdhMS4xMiAxLjEyIDAgMSAwIDAtMi4yM2gtNi43VjQuMXoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KPC9zdmc+DQo=";
export { SvgIcon38BlogPlus as ReactComponent };